import debug from 'debug';
import router from '@/router';
import onboardingService from './minified-onboarding.service';
import Logger from '../../lib/logger';
// import eventService from '../../services/event';

const log = debug('store:onboarding-super-limit');

export default {
  namespaced: true,
  state: {
    onboarding: null,
    onboardingId: null,
    step: null,
    currentRoute: null,
    nextRoute: null,
    chosenConfirmationResendType: false,
    confirmationResendType: false,
    disableTheResendCounter: false,
    showResendOptions: false,
    dueDayOptions: null,
    userId: null,
  },
  actions: {
    async getOnboarding({ commit, dispatch, state }, { userId, onboardingId }) {
      try {
        const { data } = await onboardingService
          .getOnboarding({ userId, onboardingId });
        const {
          onboarding,
        } = data;
        commit('setOnboardingData', {
          onboarding,
          userId,
        });

        commit('updateStep', { step: onboarding.step });

        if (data.dueDayOptions) {
          commit('setDueDayOptions', { dueDayOptions: data.dueDayOptions });
        }

        await router.replace({
          name: state.currentRoute,
          query: {
            ...router.currentRoute.query,
          },
        });
      } catch (error) {
        if (error && error.response && [401, 500].includes(error.response.status)) {
          commit('setIsOnboardingTokenValid', false);
          dispatch('auth/setToken', { token: null }, { root: true });
          router.replace({ name: 'onboarding-minified-credit-not-available',
            query: {
              ...router.currentRoute.query,
            } }).catch((err) => log('router error', err));
        } else {
          Logger.error(error);
          throw new Error(error);
        }
      }
    },
    async sendContractConfirmation({ state }) {
      await onboardingService.sendContractConfirmation({
        userId: state.userId,
        onboardingId: state.onboardingId,
      });
    },
    async resendConfirmation({ commit, dispatch, state }) {
      try {
        await onboardingService.resendConfirmation({
          onboardingId: state.onboardingId,
          type: state.confirmationResendType,
        });
      } catch (error) {
        if (error && error.response && error.response.status === 401) {
          commit('setIsOnboardingTokenValid', false);
          dispatch('auth/setToken', { token: null }, { root: true });
          router.replace({ name: 'onboarding-minified-credit-not-available',
            query: {
              ...router.currentRoute.query,
            } }).catch((err) => log('router error', err));
        } else {
          Logger.error(error);
          throw new Error(error);
        }
      }
    },
    async sendExpirationDate({ state }, { dueDay }) {
      await onboardingService.sendExpirationDate({
        onboardingId: state.onboardingId,
        userId: state.userId,
        dueDay,
      });
    },
    async sendConfirmationCode({ commit, dispatch, state }, { securityCode }) {
      try {
        const { data } = await onboardingService.sendConfirmation({
          onboardingId: state.onboardingId,
          securityCode,
        });

        const { onboarding } = data;

        return { success: true, onboarding };
      } catch (error) {
        if (error && error.response && error.response.status) {
          if (error.response.status === 401) {
            commit('setIsOnboardingTokenValid', false);
            dispatch('auth/setToken', { token: null }, { root: true });
            router.replace({ name: 'onboarding-minified-credit-not-available',
              query: {
                ...router.currentRoute.query,
              } }).catch((err) => log('router error', err));
            return { success: false };
          }
          return { success: false };
        }
        Logger.error(error);
        throw new Error(error);
      }
    },
    // emitEvent({ rootState, state }, {
    //   type,
    //   page = 'super-onboarding',
    // }) {
    //   const transaction = state.transaction || {};
    //   eventService.logOnboardingEvents({
    //     type,
    //     data: {
    //       ...state,
    //       apiKey: transaction.retailerId || null,
    //       page,
    //       retailerId: transaction.retailerId || null,
    //       checkoutId: transaction.checkoutId || null,
    //       user: {
    //         name: transaction.name || null,
    //         phone: transaction.phone || null,
    //         cpf: transaction.cpf || null,
    //         email: transaction.email || null,
    //         zipCode: transaction.zipCode || null,
    //         addressNumber: transaction.addressNumber || null,
    //         addressStreet: transaction.addressStreet || null,
    //         addressComplement: transaction.addressComplement || null,
    //         city: transaction.city || null,
    //         state: transaction.state || null,
    //       },
    //       productInfo: {
    //         name: transaction.productName || null,
    //         image: transaction.productImageUrl || null,
    //         url: transaction.productUrl || null,
    //         value: transaction.productPrice || null,
    //         amount: transaction.productAmount || null,
    //       },
    //       trackId: rootState.track && rootState.track.id,
    //     },
    //   }).catch((err) => log('err event', err));
    // },
    setCameraOpened({ commit }, { opened }) {
      commit('setCameraOpened', { opened });
    },
    setShowResendOptions({ commit }, { showResendOptions }) {
      commit('setShowResendOptions', { showResendOptions });
    },
  },
  mutations: {
    setShowResendOptions(state, { showResendOptions }) {
      state.showResendOptions = showResendOptions;
    },
    setIsOnboardingTokenValid(state, isValid) {
      state.isOnboardingTokenValid = isValid;
    },
    updateStep(state, { step }) {
      state.step = step;
      if (step === 'CONFIRMATION') {
        state.nextRoute = 'onboarding-minified-instructions';
        state.currentRoute = 'onboarding-minified-confirmation';
      }
      if (step === 'SELFIE') {
        state.nextRoute = 'onboarding-minified-installments-expire';
        state.currentRoute = 'onboarding-minified-instructions';
      }
      if (step === 'EXPIRATION') {
        state.nextRoute = 'onboarding-minified-contract-agreement';
        state.currentRoute = 'onboarding-minified-installments-expire';
      }
      if (step === 'AGREEMENT') {
        state.nextRoute = 'onboarding-minified-complete';
        state.currentRoute = 'onboarding-minified-contract-agreement';
      }
      if (step === 'REFUSED') {
        state.nextRoute = 'onboarding-minified-credit-not-available';
        state.currentRoute = 'onboarding-minified-credit-not-available';
      }
      if (step === 'COMPLETE') {
        state.nextRoute = 'onboarding-minified-complete';
        state.currentRoute = 'onboarding-minified-complete';
      }
    },
    setOnboardingData(state, { onboarding, userId }) {
      state.step = onboarding.step;
      state.onboarding = onboarding;
      state.userId = userId;
      state.onboardingId = onboarding._id;
    },
    setCameraOpened(state, { opened }) {
      state.cameraOpened = opened;
    },
    setChosenConfirmationResendType(state) {
      state.chosenConfirmationResendType = !state.chosenConfirmationResendType;
    },
    setResendConfirmationType(state, newConfirmationResendType) {
      state.confirmationResendType = newConfirmationResendType;
    },
    setDisableTheResendCounter(state) {
      state.disableTheResendCounter = !state.disableTheResendCounter;
    },
    setDueDayOptions(state, { dueDayOptions }) {
      state.dueDayOptions = dueDayOptions;
    },
  },
  getters: {
    dueDayOptions(state) {
      return state.dueDayOptions;
    },
    onboarding(state) {
      return state.onboarding;
    },
    deeplink(state) {
      return state.onboarding.deeplink;
    },
    userId(state) {
      return state.onboarding.userId;
    },
    phone(state) {
      return state?.onboarding?.phone || '';
    },
    onboardingId(state) {
      return state.onboarding._id;
    },
    onboardingToken(state) {
      return state.onboarding.onboardingToken;
    },
    currentRoute(state) {
      return state.currentRoute;
    },
    nextRoute(state) {
      return state.nextRoute;
    },
    hasTrustedOnboarding(state) {
      return state.onboarding.hasTrustedOnboarding;
    },
    chosenConfirmationResendType(state) {
      return state.chosenConfirmationResendType;
    },
    confirmationResendType(state) {
      return state.confirmationResendType;
    },
    disableTheResendCounter(state) {
      return state.disableTheResendCounter;
    },
    showResendOptions(state) {
      return state.showResendOptions;
    },
  },
};
